import { useTranslation } from 'react-i18next'

import { URL_PAGE_CATALOG } from '@shared/contants'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'


interface EmptyPopoverProps {
  onGoToCatalog?: () => void;
}

export default function EmptyPopover (props: EmptyPopoverProps) {
  const { onGoToCatalog } = props
  const { t: ts } = useTranslation('search')
    

  return (
    <div className={styles.root}>
      <h3 className={styles.root__title}>
        {ts('empty.title2')}
      </h3>
      <p className={styles.root__desc}>
        {ts('empty.description3')}
      </p>
      <Button
        to={URL_PAGE_CATALOG}
        className={styles.root__button}
        theme="secondary"
        onClick={onGoToCatalog}
      >
        {ts('empty.goBtn')}
      </Button>
    </div>
  )
}